import { site } from "../../config/site";

const slideLogo1 = "https://placehold.co/24x24?text=★";

export default function SlidingText() {
  return (
    <section className="sliding-text-one">
      <div className="sliding-text-one__wrap">
        <ul className="sliding-text__list marquee_mode">
          <li>
            <h2 data-hover={site.eventName} className="sliding-text__title">
              {site.eventName}
              <img src={slideLogo1} alt="Star Icon" />
            </h2>
          </li>
          <li>
            <h2 data-hover={`${site.venueCityCountry.split(",")[0]} — ${site.eventYear}`} className="sliding-text__title">
              {site.venueCityCountry.split(",")[0]} — {site.eventYear}
              <img src={slideLogo1} alt="Star Icon" />
            </h2>
          </li>
          <li>
            <h2 data-hover={site.eventName} className="sliding-text__title">
              {site.eventName}
              <img src={slideLogo1} alt="Star Icon" />
            </h2>
          </li>
          <li>
            <h2 data-hover={`${site.venueCityCountry.split(",")[0]} — ${site.eventYear}`} className="sliding-text__title">
              {site.venueCityCountry.split(",")[0]} — {site.eventYear}
              <img src={slideLogo1} alt="Star Icon" />
            </h2>
          </li>
          <li>
            <h2 data-hover={site.eventName} className="sliding-text__title">
              {site.eventName}
              <img src={slideLogo1} alt="Star Icon" />
            </h2>
          </li>
          <li>
            <h2 data-hover={`${site.venueCityCountry.split(",")[0]} — ${site.eventYear}`} className="sliding-text__title">
              {site.venueCityCountry.split(",")[0]} — {site.eventYear}
              <img src={slideLogo1} alt="Star Icon" />
            </h2>
          </li>
        </ul>
      </div>
    </section>
  );
}



